import { render, staticRenderFns } from "./WriteParagraph.vue?vue&type=template&id=bc33ee38&scoped=true&"
import script from "./WriteParagraph.vue?vue&type=script&lang=js&"
export * from "./WriteParagraph.vue?vue&type=script&lang=js&"
import style0 from "./WriteParagraph.vue?vue&type=style&index=0&id=bc33ee38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc33ee38",
  null
  
)

export default component.exports